import api from './api';

const USER_KEY = 'user';

export const authService = {
  async login(email, password) {
    const response = await api.post('/public/authenticate', { email, password });
    const user = response.data;

    // Store user info locally (session cookie is set by backend automatically)
    localStorage.setItem(USER_KEY, JSON.stringify(user));

    return { user };
  },

  async logout() {
    try {
      await api.post('/auth/users/logout');
    } catch {
      // Ignore errors — session may already be expired
    }
    localStorage.removeItem(USER_KEY);
  },

  async checkSession() {
    const response = await api.get('/auth/users/me');
    const user = response.data;
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    return user;
  },

  getCurrentUser() {
    const userStr = localStorage.getItem(USER_KEY);
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated() {
    return !!this.getCurrentUser();
  },
};
